import React from 'react';
import { useAuthStore } from '../../../store/authStore';

export default function LegacyTrainSeat() {
  const { user } = useAuthStore();

  return (
    <div className="py-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">열차좌석정보</h1>
      <div className="bg-white shadow rounded-lg p-6">
        <p className="text-gray-700">열차좌석정보 페이지 내용이 여기에 표시됩니다.</p>
      </div>
    </div>
  );
}
